import FormControl, { type FormControlProps } from "@mui/material/FormControl";
import MenuItem, { type MenuItemProps } from "@mui/material/MenuItem";
import type { FC } from "react";

export const StyledFormControl: FC<FormControlProps> = ({ sx, ...props }) => (
  <FormControl
    {...props}
    sx={[
      {
        "& .MuiInputLabel-root": { fontSize: 14 },
        "& .MuiSelect-select": { fontSize: 14 },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);

export const StyledMenuItem: FC<MenuItemProps> = ({ sx, ...props }) => (
  <MenuItem {...props} sx={[{ fontSize: 14 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} />
);
